import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-53b7ee0a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "payment-box" };
var _hoisted_4 = { class: "code" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("确认出库");
import { ref } from "vue";
import { NavBar, Icon, Button, Field, Popup, Cascader, Toast } from "vant";
import HospitalPicker from "@/components/hospitalPicker.vue";
import { requestDoctorList, sampleOutStock } from "@/api";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScanOut',
    emits: ["cancel", "ok"],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var route = useRoute();
        var router = useRouter();
        var code = ref(route.query.sampleCode);
        var doctorCascaderVisible = ref(false);
        var doctorLabel = ref("");
        var departId = ref();
        var doctorId = ref();
        var onFinish = function (_a) {
            var selectedOptions = _a.selectedOptions;
            doctorCascaderVisible.value = false;
            departId.value = selectedOptions[0].value;
            doctorId.value = selectedOptions[1].value;
            doctorLabel.value = selectedOptions.map(function (option) { return option.text; }).join("/");
        };
        var doctorOptions = ref([]);
        var hospitalPickerVisible = ref(false);
        var handleHospitalPickerOk = function (id, name) {
            hospitalId.value = id;
            hospital.value = name;
            handleHospitalPickerCancel();
        };
        var handleHospitalPickerCancel = function () {
            hospitalPickerVisible.value = false;
        };
        var getDoctorList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestDoctorList(hospitalId.value)];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            doctorOptions.value = res.data.map(function (item) { return ({
                                text: item.departName,
                                value: item.departId,
                                children: item.doctorList.map(function (doctor) { return ({
                                    text: doctor.doctorName,
                                    value: doctor.doctorId,
                                }); }),
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var hospital = ref("");
        var hospitalId = ref();
        var loading = ref(false);
        var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hospital.value) {
                            return [2 /*return*/, Toast("请选择出库医院")];
                        }
                        if (!doctorLabel.value) {
                            return [2 /*return*/, Toast("请选择科室/医生")];
                        }
                        loading.value = true;
                        return [4 /*yield*/, sampleOutStock({
                                hospitalDepartId: departId.value,
                                hospitalDoctorId: doctorId.value,
                                hospitalId: hospitalId.value,
                                // salesmanId: "",
                                sampleCode: code.value,
                            })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            Toast("出库成功！");
                            router.push("salesman-sample-list");
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "扫码出库",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(code.value), 1),
                        _createElementVNode("div", {
                            class: "",
                            style: _normalizeStyle({ marginTop: '1.7rem' })
                        }, [
                            _createVNode(_unref(Field), {
                                modelValue: hospital.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((hospital).value = $event); }),
                                label: "出库医院",
                                "is-link": "",
                                readonly: "",
                                placeholder: "请选择您就诊的医院",
                                onClick: _cache[2] || (_cache[2] = function ($event) { return (hospitalPickerVisible.value = true); })
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(Popup), {
                                show: hospitalPickerVisible.value,
                                "onUpdate:show": _cache[3] || (_cache[3] = function ($event) { return ((hospitalPickerVisible).value = $event); }),
                                position: "right",
                                style: { width: '100%', height: '100%' }
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(HospitalPicker, {
                                        userType: 2,
                                        onOk: handleHospitalPickerOk,
                                        onCancel: handleHospitalPickerCancel
                                    })
                                ]; }),
                                _: 1
                            }, 8, ["show"]),
                            _createVNode(_unref(Field), {
                                modelValue: doctorLabel.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((doctorLabel).value = $event); }),
                                name: "科室/医生",
                                label: "科室/医生",
                                "is-link": "",
                                readonly: "",
                                placeholder: "请选择您就诊医生",
                                onClick: _cache[5] || (_cache[5] =
                                    function () {
                                        getDoctorList();
                                        doctorCascaderVisible.value = true;
                                    })
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(Popup), {
                                show: doctorCascaderVisible.value,
                                "onUpdate:show": _cache[8] || (_cache[8] = function ($event) { return ((doctorCascaderVisible).value = $event); }),
                                round: "",
                                position: "bottom"
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_unref(Cascader), {
                                        modelValue: _ctx.doctor,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_ctx.doctor) = $event); }),
                                        title: "请选择您就诊医生",
                                        options: doctorOptions.value,
                                        onClose: _cache[7] || (_cache[7] = function ($event) { return (doctorCascaderVisible.value = false); }),
                                        onFinish: onFinish
                                    }, null, 8, ["modelValue", "options"])
                                ]; }),
                                _: 1
                            }, 8, ["show"])
                        ], 4)
                    ]),
                    _createVNode(_unref(Button), {
                        class: "submit-btn",
                        style: _normalizeStyle({ marginTop: '0.32rem' }),
                        block: "",
                        round: "",
                        onClick: handleSubmit
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_5
                        ]; }),
                        _: 1
                    }, 8, ["style"])
                ])
            ]));
        };
    }
});
